<template>
    <div>
        <div class="report"
             v-if="taskType!=1">
            <div class="con3_title">试题错误率</div>
            <!--<div class="radiu_list">-->
            <div class="asks"
                 v-if="asksList && asksList.length > '0'">
                <div class="ask-wrap"
                     v-for="ask in asksList"
                     @click="toaskDetail(ask)">
                    <div class="ask-up"
                         :style="{backgroundImage: 'linear-gradient(to right, transparent ' + (100-ask.wr) +'%, #FF676C 0)'}">
                        <span>{{Math.ceil(ask.wr)}}% </span>
                    </div>
                    <div class="ask-down">{{ask.title}}题</div>
                </div>
            </div>
            <div class="noresources"
                 v-else>
                <div v-cloak>
                    <p>暂无数据</p>
                </div>
            </div>
            <!--</div>-->
            <div v-if="testType!=4">
                <div class="report-tit">
                    <p>知识点掌握情况</p>
                </div>
                <div v-if="knows && knows.length > '0'">
                    <div class="know_list"
                         v-for="i in knows">
                        <p>
                            <span class="knows-tit"
                                  v-html="i.name">{{i.name}}</span>
                            <span class="knows-per">{{Math.ceil(i.rr)}}%</span>
                        </p>
                    </div>
                </div>
                <div class="noresources"
                     v-else>
                    <p>暂无数据</p>
                </div>
            </div>
        </div>
        <div class="report"
             v-else>
            <div class="report-tit">
                <p>本次作业涉及的知识点学生观看情况</p>
            </div>
            <div v-if="knows && knows.length > '0'">
                <div class="know_list"
                     v-for="i in knows">
                    <p>
                        <span class="knows-tit">{{i.name}}</span>
                        <span class="knows-num">
                            <i>{{i.study_num}}</i>/{{i.stu_num}}</span>
                    </p>
                </div>
            </div>
            <div class="noresources"
                 v-else>
                <div v-cloak>
                    <noResouse></noResouse>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import noResouse from 'COMPONENTS/noResouse.vue'
export default {
    props: ['taskType', 'testType', 'knows', 'asksList', "taskid", "classid", "sid", "loading"],
    data () {
        return {

        }
    },
    created () {
        ////console.log(this.knows)
    },
    methods: {
        toaskDetail (ask) { //错误率点击跳转
            localStorage.setItem('tabNum', 1);
            //console.log(ask)
            if (this.testType != 4) {
                this.$router.push('/errorrate/' + this.sid + '/' + this.classid + '/' + this.taskid + '/' + ask.title +
                    "?testType=" + this.testType + "&qid=" + ask.question_id + '&askid=' + ask.ask_id)
            } else {
                this.$router.push('/errorRate/quick/' + this.sid + '/' + this.classid + '/' + this.taskid + '/' + ask.title + "?testType=" +
                    this.testType + "&qid=" + ask.qid)
            }
        }
    },
    components: {
        noResouse
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
.report {
    width: 100%;
    background: #f3f6fd;
    height: auto;
    position: relative;
    .firstLoad {
        img {
            position: absolute;
            top: 9.6rem;
            left: 50%;
            margin-top: -25px / $ppr;
            margin-left: -25px / $ppr;
        }
    }
    .con3_title {
        width: 100%;
        height: 96px / $ppr;
        margin-top: 23px / $ppr;
        background: #fff;
        line-height: 96px / $ppr;
        font-size: 32px / $ppr;
        color: #333;
        padding-left: 24px / $ppr;
        font-weight: bold;
    }
    .know_list {
        width: 100%; //height: 96px/$ppr;
        border-top: 1px / $ppr solid #e8e8e8;
        background: #fff;
        padding: 32px / $ppr 0;
        p {
            display: flex;
            align-items: center;
            width: 672px / $ppr;
            line-height: 50px / $ppr;
            margin: 0 auto;
            .knows-tit {
                width: 576px / $ppr;
                font-size: 30px / $ppr;
                word-wrap: break-word;
                word-break: break-all;
                color: #999;
            }
            .knows-per {
                flex: 1;
                color: #28cd85;
                text-align: right;
            }
            .knows-num {
                flex: 1;
                color: #999;
                text-align: right;
                i {
                    color: #ff6600;
                }
            }
        }
    }
    .report-tit {
        width: 100%;
        height: 95px / $ppr;
        background: #fff;
        p {
            width: 672px / $ppr;
            line-height: 95px / $ppr;
            margin: 0 auto;
            font-size: 32px / $ppr;
            color: #333;
            font-weight: bold;
        }
    }
}

.asks {
    width: 100%;
    padding-top: 24px / $ppr;
    margin-bottom: 24px / $ppr;
    border-top: 1px / $ppr solid #e8e8e8;
    background: #fff;
    background-color: $c-fbg;
    flex-wrap: wrap;
    @include displayFlex();
    .ask-wrap {
        width: 20%;
        text-align: center;
        margin-bottom: 30px / $ppr;
        .ask-up {
            margin: 0 auto;
            height: 100px / $ppr;
            width: 100px / $ppr;
            border-radius: 100px / $ppr;
            background-color: $c-hbg;
            position: relative;
            span {
                display: block;
                width: 86px / $ppr;
                height: 86px / $ppr;
                line-height: 90px / $ppr;
                border-radius: 90px / $ppr;
                color: #ff676c;
                text-align: center;
                background-color: $c-fbg;
                position: absolute;
                top: 7px / $ppr;
                left: 7px / $ppr;
            }
        }
        .ask-down {
            margin-top: 12px / $ppr;
            display: inline-block;
            color: $c-light;
        }
    }
}

.noresources {
    width: 100%;
    height: 300px / $ppr;
    p {
        line-height: 300px / $ppr;
        text-align: center;
    }
}

[v-cloak] {
    display: none !important;
}
.report /deep/ .loading_status {
    top: 50%;
}
</style>
